import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgIcCommonly = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 56,
	height: 58,
	viewBox: "0 0 56 58",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [/* @__PURE__ */ _jsx("ellipse", {
		opacity: .9,
		cx: 28,
		cy: 28.6664,
		rx: 22,
		ry: 22.5238,
		fill: "#D2D9E0"
	}), /* @__PURE__ */ _jsx("path", {
		fillRule: "evenodd",
		clipRule: "evenodd",
		d: "M24 24.5711C24 25.7019 23.1046 26.6187 22 26.6187C20.8954 26.6187 20 25.7019 20 24.5711C20 23.4402 20.8954 22.5234 22 22.5234C23.1046 22.5234 24 23.4402 24 24.5711ZM18 33.5383C18 33.0965 18.4477 32.7383 19 32.7383H37C37.5523 32.7383 38 33.0965 38 33.5383C38 33.9801 37.5517 34.3383 36.9994 34.3383H27.9997H19C18.4477 34.3383 18 33.9801 18 33.5383ZM34 26.6187C35.1046 26.6187 36 25.7019 36 24.5711C36 23.4402 35.1046 22.5234 34 22.5234C32.8954 22.5234 32 23.4402 32 24.5711C32 25.7019 32.8954 26.6187 34 26.6187Z",
		fill: "white"
	})]
});
export default SvgIcCommonly;
